<template>
  <el-dialog title="证书选择" :visible="visible" append-to-body :close-on-click-modal="false" center width="28rem" @close="close">
    <el-alert type="error" :closable="false" v-if="errMsg" center>{{ errMsg }}</el-alert>
    <br />
    <el-row v-if="caFailed" class="center">
      <el-checkbox v-model="useDefault">设置默认手写签名图片（证书不存在时代替数字签名图片）</el-checkbox>
      <br />
      <hic-img-uploader v-if="useDefault" v-model="defaultImg" tip="手工签名：只允许小于2MB的JPG、PNG！" imgStyle="width: 100%" />
    </el-row>
    <el-form v-if="!useDefault" ref="form" :model="sign" label-width="80px" :rules="rules">
      <el-form-item label="证书" prop="cert">
        <el-select v-model="sign.certId" class="edit-wide" size="small">
          <el-option v-for="op in options" :key="op.code" :label="op.text" :value="op.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="密码" prop="pwd">
        <el-input type="password" v-model="sign.pwd" class="edit-wide" size="small"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" style="height: 1px">
      <el-button type="info" @click="close">关 闭</el-button>
      <el-button type="success" @click="ok(true)">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
    },
    data() {
      return {
        errMsg: null,
        options: [],
        sign: {
          pwd: null,
          certId: null,
        },
        rules: {
          certId: [{ required: true, message: "请选择证书！", trigger: "blur" }],
          pwd: [{ required: true, message: "密码不能为空！", trigger: "blur" }],
        },
        caFailed: false,
        useDefault: false,
        defaultImg: null,
      };
    },
    computed: {
      ...mapGetters(["user"]),
    },
    mounted() {
      GetUserList(({ retVal }) => {
        if (!retVal) {
          this.errMsg = "无法获取UKey证书列表，请使用北京CA证书助手检测环境是否正常！";
          this.caFailed = true;
          this.defaultImg = this.user.defaultImg;
        } else {
          this.caFailed = false;
          retVal.split("&&&").forEach((str) => {
            if (str) {
              this.options.push({
                code: str.split("||")[1],
                text: str.split("||")[0],
              });
            }
          });
        }
      }, {});
    },
    methods: {
      close() {
        this.$emit("update:visible", false);
      },
      ok() {
        if (this.useDefault) {
          this.$api.Oidc.update({
            auCode: "hic",
            openId: this.user.id,
            signImage: this.defaultImg,
          })
            .then((res) => {
              this.user.defaultImg = this.defaultImg;
              this.$store.commit("user", this.user);
              this.close();
            })
            .catch((err) => {
              this.$api.Oidc.add(this.user.id, {
                auCode: "hic",
                openId: this.user.id,
                signImage: this.defaultImg,
                staffId: this.user.id,
              }).then((res2) => {
                this.user.defaultImg = this.defaultImg;
                this.$store.commit("user", this.user);
                this.close();
              });
            });
          return;
        }
        try {
          this.$refs.form.validate((valid) => {
            if (!valid) {
              return;
            }
            VerifyUserPIN(
              this.sign.certId,
              this.sign.pwd,
              (res) => {
                if (res.retVal) {
                  this.$emit("ok", this.sign.certId);
                  this.errMsg = null;
                  this.pwd = null;
                  this.$emit("update:visible", false);
                } else {
                  this.errMsg = "证书与密码不匹配！";
                }
              },
              {}
            );
          });
        } catch (error) {
          console.log(error);
        }
      },
    },
  };
</script>
